module.exports = __webpack_public_path__ + "img/fenetreCreationProduction.6d05af0b.png";